/** Top nav — fixed per product sketch (not loaded from MySQL). */

export type SiteNavChild = {
  label: string;
  href: string;
};

export type SiteNavItem = {
  slug: string;
  label: string;
  href: string;
  tagline?: string;
  children?: SiteNavChild[];
};

export const SITE_NAV: SiteNavItem[] = [
  {
    slug: "ai-models",
    label: "AI Models",
    href: "/ai-models",
    tagline: "Train and run production models",
  },
  {
    slug: "ai-agents",
    label: "AI Agents",
    href: "/ai-agents",
    tagline: "Ask questions about Word, Excel, or PDF files",
  },
  {
    slug: "pos",
    label: "POS",
    href: "/pos",
    tagline: "Retail POS powered by AI",
  },
  {
    slug: "cart",
    label: "Cart",
    href: "/cart",
    tagline: "Commerce cart",
  },
  {
    slug: "trading-engine",
    label: "Trading Engine",
    href: "/trading-engine",
    tagline: "Execution and strategy",
  },
];

export const HOME_PRODUCT_CARDS = SITE_NAV.map((item) => ({
  title: item.label,
  tagline: item.tagline ?? "",
  href: item.href,
}));
